import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalInitialState } from '../types/types';

const initialState: ModalInitialState = {};

const slice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (
      state,
      action: PayloadAction<{ id: string }>,
    ) => {
      state[action.payload.id] = {
        visible: true,
      };
    },
    hideModal: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
    // removeModal: (state, action: PayloadAction<string>) => {
    //   delete state[action.payload];
    // },
  },
});

export const modalReducer = slice.reducer;
export const { showModal, hideModal } = slice.actions;
